import type { Schedule } from 'services/api';
import type { ScheduleDraftLessonChange } from '../redux';

export const findLessonById = (schedule: Schedule[], lessonId: number) => {
  for (const scheduleItem of schedule) {
    for (const timeslot of scheduleItem.timeslots) {
      const lesson = timeslot.lessons.find((lessonItem) => lessonItem.id === lessonId);

      if (lesson) {
        return { lesson, timeslot, scheduleItem };
      }
    }
  }

  return null;
};

export const hasLessonChanges = (change?: ScheduleDraftLessonChange) => {
  if (!change) return false;

  return 'pinned' in change || 'teacherId' in change || 'roomId' in change || 'timeslot' in change;
};
